import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import GuardTurnedOn from './icons/guard-turned-on.svg';
import GuardActivating from './icons/guard-activating.svg';
import GuardTurnedOff from './icons/guard-unlock.svg';
import SirenTurnedOn from './icons/siren-turned-on.svg';
import SirenTurnedOff from './icons/siren-turned-off.svg';
import WebastoTurnedOn from './icons/webasto-turned-on.svg';
import WebastoTurnedOff from './icons/webasto-turned-off.svg';
import EngineTurnedOn from './icons/engine-turned-on.svg';
import EngineTurnedOff from './icons/engine-turned-off.svg';
import AutostartTurnedOn from './icons/autostart-turned-on.svg';
import AutostartTurnedOff from './icons/autostart.svg';
import { CustomIcon } from 'console/shared/components/icon/custom';
export function getVehicleControlIconWithLabel(state) {
    switch (state) {
        case 'guard-turned-on':
            return {
                label: 'Охрана',
                icon: _jsx(CustomIcon, { Icon: GuardTurnedOn, fontSize: "1.4em" }),
            };
        case 'guard-activating':
            return {
                label: 'Охрана',
                icon: (_jsx(CustomIcon, { Icon: GuardActivating, viewBox: "0 0 44 44", fontSize: "2.2em" })),
            };
        case 'guard-turned-off':
            return {
                label: 'Охрана',
                icon: (_jsx(CustomIcon, { Icon: GuardTurnedOff, fontSize: "1.4em", fill: "#474747", opacity: "0.7" })),
            };
        case 'siren-turned-on':
            return {
                label: 'Сирена',
                icon: (_jsx(CustomIcon, { Icon: SirenTurnedOn, fontSize: "2em", viewBox: "0 0 44 44" })),
            };
        case 'siren-turned-off':
            return {
                label: 'Сирена',
                icon: (_jsx(CustomIcon, { Icon: SirenTurnedOff, fontSize: "2em", viewBox: "0 0 44 44" })),
            };
        case 'webasto-turned-on':
            return {
                label: 'Подогрев',
                icon: (_jsx(CustomIcon, { Icon: WebastoTurnedOn, fontSize: "2em", viewBox: "0 0 44 44" })),
            };
        case 'webasto-turned-off':
            return {
                label: 'Подогрев',
                icon: (_jsx(CustomIcon, { Icon: WebastoTurnedOff, fontSize: "2em", viewBox: "0 0 44 44" })),
            };
        case 'engine-turned-on':
            return {
                label: 'Блокировка',
                icon: (_jsx(CustomIcon, { Icon: EngineTurnedOn, fontSize: "2em", viewBox: "0 0 44 44" })),
            };
        case 'engine-turned-off':
            return {
                label: 'Блокировка',
                icon: (_jsx(CustomIcon, { Icon: EngineTurnedOff, fontSize: "2em", viewBox: "0 0 44 44" })),
            };
        case 'autostart-turned-on':
            return {
                label: 'Автозапуск',
                icon: (_jsx(CustomIcon, { Icon: AutostartTurnedOn, fontSize: "2em", viewBox: "0 0 44 44" })),
            };
        case 'autostart-turned-off':
            return {
                label: 'Автозапуск',
                icon: (_jsx(CustomIcon, { Icon: AutostartTurnedOff, opacity: "0.7", fontSize: "2em", viewBox: "0 0 44 44" })),
            };
        case 'autostart-webasto-turned-on':
            return {
                label: 'Подогрев',
                icon: (_jsx(CustomIcon, { Icon: WebastoTurnedOn, fontSize: "2em", viewBox: "0 0 44 44" })),
            };
        case 'autostart-webasto-turned-off':
            return {
                label: 'Подогрев',
                icon: (_jsx(CustomIcon, { Icon: WebastoTurnedOff, opacity: "0.7", fontSize: "2em", viewBox: "0 0 44 44" })),
            };
        default:
            break;
    }
    return { label: '', icon: _jsx(_Fragment, {}) };
}
